import { EventCategory, ModalEvent, ModalEventNames } from '@lendi/analytics-web';

import { lendiAnalytics } from './analytics';
import { eventTracking } from './base';

// Modal event
function baseModalDisplayTracking(
  event_name: ModalEventNames,
  analytics: ReturnType<typeof lendiAnalytics>,
  props: Pick<ModalEvent, 'modalName' | 'modalType'> & { origin: string }
) {
  eventTracking<ModalEvent & { origin: string }>(analytics, { ...props, event_name, category: EventCategory.FUNNELS });
}

export const modalEventTracking = (analytics: ReturnType<typeof lendiAnalytics>) => ({
  displayed: baseModalDisplayTracking.bind(undefined, ModalEventNames.MODAL_DISPLAYED).bind(null, analytics),
  clicked: baseModalDisplayTracking.bind(undefined, ModalEventNames.MODAL_CLICKED).bind(null, analytics),
  closed: baseModalDisplayTracking.bind(undefined, ModalEventNames.MODAL_CLOSED).bind(null, analytics),
});
